import { useState } from 'react'
import { useDebounce } from '@/shared/hooks'
import { useRecipes } from './useRecipes'

export function useRecipeSearch() {
  const [query, setQuery] = useState('')
  const debouncedQuery = useDebounce(query, 300)
  const { data, isLoading } = useRecipes({
    search: debouncedQuery || undefined,
  })

  return { query, setQuery, recipes: data, isLoading }
}
